function getOSLegacy() {
    try {
        const ua = navigator.userAgent || '';

        if (/android/i.test(ua)) return { os: 'Android' };
        if (/iPad|iPhone|iPod/.test(ua)) return { os: 'iOS' };
        if (/Win/.test(ua)) return { os: 'Windows' };
        if (/Mac/.test(ua)) return { os: 'macOS' };

        return { os: 'Unknown' };
    } catch (err) {
        console.error('Legacy OS detection failed:', err);
        return { os: 'Unknown' };
    }
}

async function getMobileOS() {
    try {
        if (!navigator.userAgentData) {
            return getOSLegacy();
        }

        const data = await navigator.userAgentData.getHighEntropyValues([
            'platform',
            'platformVersion',
            'model',
        ]);

        return {
            os: data.platform || 'Unknown',
            version: data.platformVersion || 'Unknown',
            model: data.model || 'Unknown',
        };
    } catch (err) {
        console.error('Modern OS detection failed:', err);
        return getOSLegacy();
    }
}

async function detectOS() {
    try {
        if (navigator.userAgentData) {
            const data = await navigator.userAgentData.getHighEntropyValues([
                'platform',
                'platformVersion',
            ]);

            const os = data.platform || 'Unknown';
            const version = data.platformVersion || '';
            return version ? `${os} ${version}` : os;
        }

        const legacy = getOSLegacy();
        return legacy.os || 'Unknown';
    } catch (err) {
        console.error('detectOS failed:', err);
        return 'Unknown';
    }
}

// Export legacy separately if needed
export { getOSLegacy, getMobileOS, detectOS };
